import { Pipe, PipeTransform } from '@angular/core';
import { AttributesGroup } from '@app/shared/interfaces/Attribute';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { CustomAttribute, CustomAttributeGroup } from '../models/AttributeDTO';

@Pipe({
  name: 'AttributesToField',
})
export class AttributesToFieldPipe implements PipeTransform {
  transform(attribute: CustomAttribute): any {
    const field: ModelField = {
      Code: attribute.id,
      DataType: +attribute.type!,
      Required: attribute.isRequired,
      Title: attribute.label,
      Scope: attribute.scope ?? '1',
      Object: attribute.object,
      AdditionalData: attribute.additionalData ?? undefined,
      Visible: attribute.visible,
    };

    return field;
  }
}
